module.exports = __webpack_public_path__ + "static/26-12e135a03ba81480c5edbee84817b89f.jpg";